<template>
  <div>
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-form ref="searchForm" :inline="true" class="" :model="searchForm">
          <el-form-item label="业务实体:" prop="bussinessEntity">
            <el-select
              v-model="searchForm.bussinessEntity"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in businessEntity"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="收款编号:" prop="telegraphicTransferNum" clearable>
            <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入收款编号" />
          </el-form-item>
          <el-form-item label="收款日期:" prop="arrivalMoneyStartDate">
            <div class="rj-flex">
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.arrivalMoneyStartDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
              <div style="display: inline-block;width: 10px;text-align: center">
                -
              </div>
              <div class="rj-flex__item">
                <el-date-picker
                  v-model="searchForm.arrivalMoneyEndDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="银行名称:" prop="accountCompany">
            <el-select
              v-model="searchForm.accountCompany"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in bankName"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="原始客户名称:" prop="importCompany" clearable>
            <el-input v-model.trim="searchForm.importCompany" placeholder="请输入原始客户名称" />
          </el-form-item>
          <el-form-item label="修改后客户名称:" prop="newImportCompany" clearable>
            <el-input v-model.trim="searchForm.newImportCompany" placeholder="请输入修改后客户名称" />
          </el-form-item>
          <el-form-item label="收款单已生成:" prop="isReceipt">
            <el-select
              v-model="searchForm.isReceipt"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in generatedVoucher"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="已分配:" prop="isAssigned">
            <el-select
              v-model="searchForm.isAssigned"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="option in allocated"
                :key="option.dictValue"
                :label="option.dictLabel"
                :value="option.dictValue"
              />
            </el-select>
          </el-form-item>

          <el-button type="primary" :loading="isLoading" @click="doSearch">
            查询
          </el-button>
          <el-button type="default" @click="resetForm('searchForm')">
            重置
          </el-button>
          <!-- <el-button type="primary">导出资金认领详细</el-button> -->
        </el-form>
      </div>
    </div>
    <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
      <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
      <el-table-column prop="bussinessEntity" label="业务实体" align="left" fixed="left" />
      <el-table-column prop="accountCompany" label="银行名称" align="left" width="180px" />
      <el-table-column prop="remittanceDate" label="收款日期" align="left" width="180px" />
      <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left" width="190px">
        <template v-slot="{row}">
          <el-button type="text" class="el-btn-text-left" @click="showInfo(row.telegraphicTransferNum)">
            {{ row.telegraphicTransferNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="remittanceAmount" label="收款总额" align="right" header-align="left" width="110px" />
      <el-table-column prop="actualRemittanceAmount" label="净收款额" align="right" header-align="left" width="110px" />
      <el-table-column prop="serviceFee" label="手续费" align="right" header-align="left" width="110px" />
      <el-table-column prop="currency" label="币种" align="left" />
      <el-table-column prop="importCompany" label="原始客户名称" align="left" width="180px" />
      <el-table-column prop="newImportCompany" label="修改后客户名称" align="left" width="110" />
      <el-table-column prop="isAssigned" label="已分配" align="left">
        <template v-slot="{row}">
          <span v-if="row.isAssigned">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="摘要" align="left" min-width="110" />
      <el-table-column prop="isReceipt" label="已生成收款单" align="left" width="110">
        <template v-slot="{row}">
          <span v-if="row.isReceipt">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDelete" label="是否已废弃" align="left" width="110">
        <template v-slot="{row}">
          <span v-if="row.isDelete">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="financeState" width="170" label="状态" align="left">
        <template v-slot="{row}">
          <span>{{ row.financeState }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left" fixed="right" width="210">
        <template v-slot="{row}">
          <span v-if="!row.isDelete">
            <el-button v-if="row.state==='修改客户' &&!row.isReceipt &&!row.isAssigned" type="text" @click="change(row)">修改客户</el-button>
            <el-button v-if="row.state==='编辑客户'" type="text" @click="edit(row)">编辑客户</el-button>
            <el-button v-if="row.rebuild === null" type="text" @click="nullifyReceipt(row)">作废来款单</el-button>
            <el-button v-if="row.state==='编辑客户'" type="text" @click="noChange(row)">放弃修改客户</el-button>
            <el-button v-if="!row.isDelete" type="text" @click="refund(row)">申请退款</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top: 10px">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>
    <!-- TODO -->
    <!-- 分页 -->
    <el-dialog v-if="remittanceVisible" title="国内电汇详细信息" :visible.sync="remittanceVisible" width="800px">
      <remittance-info-box :id="telegraphicTransferNum" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="remittanceVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改客户名称" :visible.sync="changeName" width="800px" @close="changeClose">
      <changeName ref="changeName" :row-data="changeData" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="changeName = false">关 闭</el-button>
        <el-button type="primary" :loading="isLoadingChangeSure" @click="sureChange">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑客户名称" :visible.sync="editName" width="800px" @close="editClose">
      <editName v-if="editName" ref="editName" :row-data="changeData" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="editName = false">关 闭</el-button>
        <el-button type="primary" :loading="isLoadingEditSure" @click="editSure">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="nullifyReceiptVisible" title="作废来款单" :visible.sync="nullifyReceiptVisible" width="800px" @close="nullifyReceiptClose">
      <span style="margin-right:5px">作废类型：<span style="color:red">*</span> </span>
      <el-radio v-model="radio" label="1">
        委托付款
      </el-radio>
      <el-radio v-model="radio" label="0">
        认款主档错误
      </el-radio>
      <div style="color:red">
        说明：委托付款：指A公司（销售）帮B公司（直接客户）付款分配后，B公司又付款给我司，商务申请作废后，财务会重新抛A公司的来款到CES，商务/渠道可以申请实际退款到A公司或不退款A公司用于其他订单；
        <br>
        认款主档数据错误：指来款不应该是销售订单的款被分配到了销售订单上，在没有开发货单的前提下，商务申请作废财务审批后，这笔电汇单作废且不再重新推送来款到CES，电汇单对应的分配记录将全部取消。
      </div>
      <div style="margin:10px 0 10px 0">
        作废原因 <span style="color:red">*</span>
      </div>
      <el-input v-model="fileDetail" type="textarea" maxlength="100" style="margin:0 0 10px 0" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" :loading="isSubmitLoading" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="isSubmitLoading" @click="nullifySubmit">提交申请</el-button>
      </span>
    </el-dialog>
    <el-dialog title="退款" :visible.sync="applyVisible" width="800px">
      <remittance-apply-box v-if="applyVisible" :id="remittanceInfoID" :currency="remittanceCurrency" @close="changeApplyVisible" @set-loading="(isTrue) => isSubmitCLoading = isTrue" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyVisible = false">取 消</el-button>
        <el-button type="primary" :loading="isSubmitCLoading" @click="submitApply">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import remittanceInfoBox from './components/remittanceInfoBox';
import remittanceApplyBox from './components/remittanceApplyBox';
import changeName from './components/changeName';
import editName from './components/editName';
import eventBus from '@/libs/eventBus';
// import cancellation from './cancellation.vue';
import { getDictData, selectTelegraphicTransferList, modifyCustomerName, telApprovalEdit, undoDistributionAgree, scrapReceipt, checkApplyCount } from '@/API';
import { checkExportCompliance } from '@/libs/exportCompliance';
export default {
  components: {
    remittanceInfoBox,
    changeName,
    editName,
    remittanceApplyBox
    // cancellation
  },
  data () {
    return {
      cancellationVisible: false,
      searchForm: {
        bussinessEntity: '',
        telegraphicTransferNum: '',
        arrivalMoneyStartDate: '',
        arrivalMoneyEndDate: '',
        accountCompany: '',
        importCompany: '',
        newImportCompany: '',
        isReceipt: '',
        isAssigned: ''
      },
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.arrivalMoneyStartDate) {
            let date = new Date(this.searchForm.arrivalMoneyStartDate);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isLoading: false,
      tableData: [],
      remittanceVisible: false,
      remittanceInfoID: '', // 电汇底单编号
      remittanceCurrency: '',
      changeName: false, // 修改客户名称
      editName: false,
      businessEntity: [],
      bankName: [],
      generatedVoucher: [],
      allocated: [],
      changeData: {},
      isLoadingChangeSure: false,
      isLoadingEditSure: false,
      telegraphicTransferNum: '',
      nullifyReceiptVisible: false,
      radio: '1',
      fileDetail: '',
      postData: {},
      isSubmitLoading: false,
      applyVisible: false,
      isSubmitCLoading: false
    };
  },
  computed: {},
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = ['business_entity', 'bank_name', 'generated_voucher', 'allocated'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'business_entity') {
              this.businessEntity = item.dictDataVOS;
            }
            if (item.dictType === 'bank_name') {
              this.bankName = item.dictDataVOS;
            }
            if (item.dictType === 'generated_voucher') {
              this.generatedVoucher = item.dictDataVOS;
            }
            if (item.dictType === 'allocated') {
              this.allocated = item.dictDataVOS;
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      selectTelegraphicTransferList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
          this.isLoading = false;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.arrivalMoneyEndDate = '';
      this.doSearch();
    },
    showInfo (val) {
      this.telegraphicTransferNum = val;
      this.remittanceVisible = true;
    },
    change (row) {
      this.changeName = true;
      this.changeData = row;
    },
    edit (row) {
      this.editName = true;
      this.changeData = row;
    },
    noChange (row) {
      this.$confirm('您确定要放弃修改来款客户名称吗？放弃修改后将不可再次申请修改来款客户名称', '友情提示', {
        confirmButtonText: '放弃修改',
        cancelButtonText: '返回继续修改',
        type: 'warning'
      }).then(() => {
        scrapReceipt(row.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('修改客户成功');
            this.initData();
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    },
    // 确认编辑
    async editSure () {
      let newName = this.$refs.editName.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      let parmas = {
        id: this.changeData.telApprovalId,
        newImportCompany: this.$refs.editName.newName,
        fileList: this.$refs.editName.fileList
      };
      this.isLoadingEditSure = true;
      const decision = await checkExportCompliance(this, {
        businessScene: 'TEL_APPROVAL_EDIT',
        originalBizId: String(parmas.id || ''),
        subjectNameList: [parmas.newImportCompany]
      });
      if (!decision.allowBusiness) {
        this.isLoadingEditSure = false;
        return;
      }
      telApprovalEdit(parmas).then((res) => {
        this.isLoadingEditSure = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('编辑成功');
          this.editClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isLoadingEditSure = false;
      });
    },
    // 确认修改
    async sureChange () {
      let newName = this.$refs.changeName.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      let parmas = [{
        telId: this.changeData.id,
        newImportCompany: this.$refs.changeName.newName,
        fileList: this.$refs.changeName.fileList
      }];
      this.isLoadingChangeSure = true;
      const decision = await checkExportCompliance(this, {
        businessScene: 'TEL_APPROVAL_MODIFY',
        subjectNameList: [newName]
      });
      if (!decision.allowBusiness) {
        this.isLoadingChangeSure = false;
        return;
      }
      modifyCustomerName(parmas).then((res) => {
        this.isLoadingChangeSure = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('修改成功');
          this.changeClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isLoadingChangeSure = false;
      });
    },
    // 修改关闭
    changeClose () {
      this.$refs.changeName.newName = '';
      this.$refs.changeName.fileList = [];
      this.changeName = false;
    },
    // 编辑关闭
    editClose () {
      this.$refs.editName.newName = '';
      this.$refs.editName.fileList = [];
      this.editName = false;
    },
    cancellation () { },
    doSubmit (val) {
      if (!val.causeRevocation) {
        this.$message.warning('作废原因不能为空');
        return false;
      }
    },
    nullifyReceiptClose () {
      this.nullifyReceiptVisible = false;
      this.fileDetail = '';
      this.radio = '1';
    },
    nullifyReceipt (row) {
      this.postData.ids = [row.id];
      this.nullifyReceiptVisible = true;
    },
    nullifySubmit () {
      if (!this.fileDetail) {
        this.$message.error('作废原因不能为空');
        return false;
      }
      this.isSubmitLoading = true;
      this.postData.type = 2;
      this.postData.reason = this.fileDetail;
      this.postData.rebuild = parseInt(this.radio);
      undoDistributionAgree(this.postData).then((res) => {
        this.isSubmitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '作废成功'
          });
          this.doSearch();
          this.nullifyReceiptClose();
        }
      }).catch(() => {
        this.isSubmitLoading = false;
      });
    },
    cancel () {
      this.nullifyReceiptClose();
    },
    async refund (row) {
      let ischeck = 'true';
      let res = await checkApplyCount(row.telegraphicTransferNum);
      let json = res.data;
      if (json.status === '200') {
        ischeck = json.data;
      } else {
        this.$message.warning('接口发生错误');
        return false;
      }

      if (ischeck === 'true') {
        this.applyVisible = true;
        this.remittanceInfoID = row.telegraphicTransferNum;
        this.remittanceCurrency = row.currency || '';
      } else {
        this.$message.warning('已经申请过退款');
      }
    },
    // 确认提交退款信息
    submitApply () {
      eventBus.$emit('submitApplyInfo');
    },
    changeApplyVisible (val) {
      this.applyVisible = val;
      this.doSearch();
    }
  }
};
</script>

<style>

</style>
